import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import ApplicationService from "../../services/applications/Application.service"
import HistoryComponent from "components/Application/History"

let appService = null

const History = props => {
  const [history, sethistory] = useState()
  const [mounted, setmounted] = useState(false)

  useEffect(() => {
    appService = new ApplicationService(
      JSON.parse(localStorage.getItem("authUser"))
    )
    appService
      .getHistory(props.location.search.split("=")[1])
      .then(response => {
        if (response.status) {
          sethistory(response.data)
          setmounted(true)
        }
      })
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>History | Staff</title>
        </MetaTags>
        <div className="container-fluid">
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Application History</h6>
              </Col>
            </Row>
          </div>
          {mounted ? <HistoryComponent data={history} /> : null}
          
        </div>
      </div>
    </React.Fragment>
  )
}

export default History
